import { Component, OnInit, HostBinding } from '@angular/core';
import { AIAssistantService } from './services/ai-assistant.service';
import { AIConfig } from './models/ai-config.interface';
import { StandardAppGuard } from './guards/standard-app.guard';

@Component({
  selector: 'xpw-ai-assistant',
  templateUrl: './ai-assistant.component.html',
  styleUrls: ['./ai-assistant.component.less'],
})
export class AIAssistantComponent implements OnInit {
  config: AIConfig;
  isOpen$ = this.aiService.isOpen$;

  // Flag to check if we're in standard app mode
  isStandardApp = false;

  // Host bindings for positioning
  @HostBinding('class.bottom-right') get isBottomRight() {
    return this.config?.position === 'bottom-right';
  }
  @HostBinding('class.bottom-left') get isBottomLeft() {
    return this.config?.position === 'bottom-left';
  }
  @HostBinding('class.top-right') get isTopRight() {
    return this.config?.position === 'top-right';
  }
  @HostBinding('class.top-left') get isTopLeft() {
    return this.config?.position === 'top-left';
  }

  constructor(
    public aiService: AIAssistantService,
    private standardAppGuard: StandardAppGuard,
  ) {}

  ngOnInit() {
    this.config = this.aiService.getConfig();

    // Check if we're in standard app mode (not iframe)
    this.isStandardApp = this.standardAppGuard.canActivate();
  }

  onButtonClick(): void {
    this.aiService.toggle();
  }

  onModalClose(): void {
    this.aiService.close();
  }

  onChatClose(): void {
    this.aiService.close();
  }
}
